export const session = sessionStorage;
